// TODO - remove this once all customers upgrade, or replace this with an API
export const FEATURES_SUPPORT_VERSIONS = {
  DB_QUERY_ON_RESTORE_ACCOUNT: '1.3.0',
  SOURCE_ACCOUNT_METRICS: '1.5.4',
  RESTORE_ACCOUNT_METRICS: '1.5.11',
};
